type PropType<T> = {
  type: T
  validator?: (v: unknown) => boolean
  default?: any
}

type PropTypeWithMethods<T> = PropType<T> & {
  def: (value: any) => PropTypeWithMethods<T>
  validate: (validator: (v: unknown) => boolean) => PropTypeWithMethods<T>
}

function createPropType<T>(type: T): PropTypeWithMethods<T> {
  const proxy = new Proxy({} as PropTypeWithMethods<T>, {
    get(target, prop, receiver) {
      if (prop === 'type') return type
      if (prop === 'def') {
        return (value: any) => {
          target.default = value
          return receiver
        }
      }
      if (prop === 'validate') {
        return (validator: (v: unknown) => boolean) => {
          target.validator = validator
          return receiver
        }
      }
      return (target as any)[prop]
    }
  })
  return proxy
}

export const number = createPropType(Number)
export const string = createPropType(String)
export const boolean = createPropType(Boolean)
export const func = createPropType(Function)
export const object = createPropType(Object)
export const array = createPropType(Array)

export const propTypes = {
  string: createPropType(String),
  number: createPropType(Number),
  bool: createPropType(Boolean),
  func: createPropType(Function),
  object: createPropType(Object),
  array: createPropType(Array),
  oneOf: <T>(values: T[]) => {
    const proxy = new Proxy({} as any, {
      get(target, prop, receiver) {
        if (prop === 'type') return values
        if (prop === 'def') {
          return (value: T) => {
            target.default = value
            return receiver
          }
        }
        if (prop === 'validator') {
          return (validator: (v: unknown) => boolean) => {
            target.validator = validator
            return receiver
          }
        }
        return (target as any)[prop]
      }
    })
    return proxy
  },
  oneOfType: <T>(types: T[]) => {
    const proxy = new Proxy({} as any, {
      get(target, prop, receiver) {
        if (prop === 'type') return types
        if (prop === 'def') {
          return (value: any) => {
            target.default = value
            return receiver
          }
        }
        return (target as any)[prop]
      }
    })
    return proxy
  }
}

export default propTypes
